export default __webpack_public_path__ + "static/media/SZ10.01.8a2c1c05.mp3";